export default __webpack_public_path__ + "static/media/CarImages.PRunnerGallery1.5e8fa76a.jpg";